"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryRulesPrettyPrinter = void 0;
const customerSubUnit_1 = require("../customerSubUnit");
const deliveryRulesUtils_1 = require("./deliveryRulesUtils");
class DeliveryRulesPrettyPrinter {
    constructor(deliveryRules) {
        this.deliveryRules = deliveryRules || customerSubUnit_1.defaultSelectedDeliveryRules;
    }
    getDeliveryRulesAsOpeningHourString() {
        if (!this.deliveryRules) {
            return '';
        }
        return this.deliveryRules
            .filter(rule => !!rule.selectedRoute?.weekday)
            .map(rule => {
            return `${(0, deliveryRulesUtils_1.getWeekdayName)(rule.selectedRoute?.weekday)}: Öppet`;
        })
            .join(', ');
    }
}
exports.DeliveryRulesPrettyPrinter = DeliveryRulesPrettyPrinter;
